export default "__VITE_ASSET__89b6_xjz__"